// extracted by mini-css-extract-plugin
module.exports = {"mapStylePicker":"MapStylePicker_mapStylePicker__3Z1Wn","girdStyle":"MapStylePicker_girdStyle__2JvL_"};